konnyScript(function($){

  var holiswiper = new Swiper("#holi_swiper_slide1", {
    slidesPerView:1.19,
    slidesPerGroup:1,
    spaceBetween:'3%',
    centeredSlides:true,
    scrollbar:{
      el: '#holi_swiper_slide1 .swiper-scrollbar',
      hide:true,
    },
    pagination: {
      el: '#holi_swiper_slide1 .swiper-pagination',
      clickable:true,
    },
    navigation: {
      nextEl: '#holi_swiper_slide1 .swiper-button-next',
      prevEl: '#holi_swiper_slide1 .swiper-button-prev',
    },
  });

  $('.holiEvent .notiBox .notiTit').click(function(){
    var notiBox = $(this).parent('.notiBox');
    notiBox.toggleClass('on');
  });
  
});